import React, { Component, } from 'react';
import {Modal, ModalBody, ModalHeader, Card, CardBody, CardHeader, Row, Button, ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem} from 'reactstrap';
import HeaderComponent from "../../components/header/HeaderComponent";

var stateManager = require('../../utils/state/stateManager.js');
var navigationDialogueAction = require('../../utils/state/actions/views/navigationDialogue/navigationDialogueAction');

var stringUtil = require('../../utils/string/stringUtil.js');
var commonUtility = require('../../utils/domain/commonUtility.js');
var staffUtility = require('../../utils/domain/staff/staffUtility.js');
var staffAccessUtility = require('../../utils/domain/staff/staffAccessUtility');
var formatter = require('../../utils/formatter/formatter.js');
var validator = require('../../utils/validator/validator.js');
var guidUtil = require('../../utils/guid/guidUtil.js');
var constants = require('../../utils/domain/constants.js');
var viewUtil = require('../../utils/view/viewUtil.js');
var dateUtil = require('../../utils/dateUtil/dateUtil.js');
var printUtil = require('../../utils/print/printUtil.js');
var rmsApiProxyRetry = require('../../utils/api/rmsApiProxyRetry.js')
var jobsServer = require('../../utils/jobs/jobsServer.js')
var localizationUtils = require('../../utils/domain/localizationUtils')
var translator = require('../../utils/translator/translator')

const percentageDenominations = [5, 10, 20, 50];

class DiscountVoucherView extends Component
{
    
    constructor(props)
    {   
        super(props);

        this.handleCancel = this.handleCancel.bind(this);
        this.onCreateButtonClick = this.onCreateButtonClick.bind(this); 

        this.renderOutputScreenPanel = this.renderOutputScreenPanel.bind(this);
        this.renderDiscountOfferTypePanel = this.renderDiscountOfferTypePanel.bind(this);
        this.renderDiscountOfferTypePanel = this.renderDiscountOfferTypePanel.bind(this);
        this.renderDiscountReasonPanel = this.renderDiscountReasonPanel.bind(this);
        this.renderMinimumOrderAmountPanel = this.renderMinimumOrderAmountPanel.bind(this);
        this.renderKeyPadPanel = this.renderKeyPadPanel.bind(this);
        this.displayDiscountReason = this.displayDiscountReason.bind(this);
        this.displayDiscountOfferTypeWithAmount = this.displayDiscountOfferTypeWithAmount.bind(this);
        this.onDiscountOfferTypeClick = this.onDiscountOfferTypeClick.bind(this);
        this.onNumberEntered = this.onNumberEntered.bind(this);
        this.validateDiscountVoucher = this.validateDiscountVoucher.bind(this);
        this.postDiscountVoucher = this.postDiscountVoucher.bind(this);
        

        this.state ={};
        this.state.displayAmount = 0.0;
        this.state.voucherCode = guidUtil.generateVoucherCode();
        this.state.keyPadDisabled = false;
        this.state.discountReason = "";
        this.state.discountOfferType = "";
        this.state.minimumOrderAmount = 0;
    }

    render() 
    {
        return (<div>
                    <Modal isOpen={true} backdrop={true} animation={false} fade={false} size="lg">
                        <ModalHeader
                            close={
                                <div>
                                    <Button className="btn-cancel" onClick={this.handleCancel}>{translator.getLabel("cancel")}</Button>&nbsp;&nbsp;
                                    <Button className="btn-ok" onClick={this.onCreateButtonClick}>{translator.getLabel("create")}</Button>
                                </div>
                            }>
                            <span className="window-title">{translator.getLabel("discount_voucher")}</span>
                        </ModalHeader>
                        <ModalBody>
                            {this.renderDiscountVoucherBody()}
                        </ModalBody>
                    </Modal>
                </div>)

    }

    renderDiscountVoucherBody()
    {
        return(
                                        
            <div style={{height:'75vh'}}>
                
                <table height="100%" width="100%">
                    <tr height="10%">
                        {this.renderOutputScreenPanel()}
                    </tr>
                    
                    <tr height="0%">
                        <td>
                            <hr style={{margin:'0px', marginBottom:'10px'}}/>
                        </td>
                    </tr>
                    
                    <tr>
                        <td height="100%">
                            {this.renderKeyPadPanel()}
                        </td>
                    </tr>
                </table>   

            </div>                                              
        );        
    }

    renderOutputScreenPanel()
    {
        return (
                <div style={{background:"white", color:"#484848", height:"100%", width:"100%", padding:"0px 5px 5px 5px"}}>
                    <table width="100%" height="100%">                                    
                        
                        <tr>
                            <td>
                                <div style={{color:"#484848", fontSize:'2.5rem', fontWeight:'bold'}}>
                                    {this.state.voucherCode}
                                </div>
                            </td>
                            
                            <td>
                                <div align="right" style={{color:"#484848", fontSize:'2.5rem', fontWeight:'bold'}}>
                                    {this.displayDiscountOfferTypeWithAmount(this.state.displayAmount)}
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td>Minimum Order Amount:</td>
                            <td><div align="right">{formatter.convertToCurrencyFormat(this.state.minimumOrderAmount)}</div> </td>
                        </tr>

                        {this.displayDiscountReason()}

                    </table>    
                </div>

                )
    }

    displayDiscountReason()
    {
        var component = null;

        if(!stringUtil.isStringNullOrEmpty(this.state.discountReason))
        {
            component = <tr>
                            <td>{translator.getLabel("discount_reasons")}</td>
                            <td><div align="right">{this.state.discountReason}</div> </td>
                        </tr>
        }

        else
        {
            component = <tr>
                            <td>&nbsp;</td>
                        </tr>
        }

        return component;
    }

    renderKeyPadPanel()
    {
        let denominations;
        if(this.state.discountOfferType == constants.DiscountVoucherTypes.Fixed)
            denominations = localizationUtils.getCurrencyDenominations();
        else
            denominations = percentageDenominations;

        return(
            <table width="100%" height="100%">  

                <tr width="100%" height="30%">
                    <table width="100%" height="100%" style={{borderCollapse: 'separate', borderSpacing: '4px'}}>
                        
                        <tr width="100%" height="50%">
                            <td colSpan="2">
                            {this.renderDiscountReasonPanel()}
                            </td>
                        </tr>

                        <tr width="100%" height="50%">
                            <td width="50%">                                                                
                                {this.renderMinimumOrderAmountPanel()}
                            </td>
                            <td width="50%">
                                {this.renderDiscountOfferTypePanel()}
                            </td>                        
                        </tr>

                    </table>
                </tr>
                
                <tr width="100%"  height="70%">
                    
                    <table width="100%" height="100%" style={{borderCollapse: 'separate', borderSpacing: '4px'}}>
                        <tr>
                            <td width="25%">
                                <Button color="secondary" disabled={this.state.keyPadDisabled} style={{width:'100%', height:'100%', fontSize:'1.3rem'}} onClick={()=>{this.onNumberEntered(7)}} className='payment-number-button-style'>7</Button>
                            </td>
                            <td width="25%">
                                <Button color="secondary" disabled={this.state.keyPadDisabled} style={{width:'100%', height:'100%', fontSize:'1.3rem'}} onClick={()=>{this.onNumberEntered(8)}} className='payment-number-button-style'>8</Button>
                            </td>
                            <td width="25%">
                                <Button color="secondary" disabled={this.state.keyPadDisabled} style={{width:'100%', height:'100%', fontSize:'1.3rem'}} onClick={()=>{this.onNumberEntered(9)}} className='payment-number-button-style'>9</Button>
                            </td>
                            <td width="25%">
                                <Button disabled={this.state.keyPadDisabled} style={{width:'100%', height:'100%', fontWeight:'bold', fontSize:'1.3rem', background: '#33658A'}} onClick={()=>{this.onNumberEntered(denominations[0] * 100)}}>{this.displayDiscountOfferTypeWithAmount(denominations[0])}</Button>
                            </td>
                        </tr>

                        <tr>
                            <td>
                                <Button color="secondary" disabled={this.state.keyPadDisabled} style={{width:'100%', height:'100%', fontSize:'1.3rem'}} onClick={()=>{this.onNumberEntered(4)}} className='payment-number-button-style'>4</Button>
                            </td>
                            <td>
                                <Button color="secondary" disabled={this.state.keyPadDisabled} style={{width:'100%', height:'100%', fontSize:'1.3rem'}} onClick={()=>{this.onNumberEntered(5)}} className='payment-number-button-style'>5</Button>
                            </td>
                            <td>
                                <Button color="secondary" disabled={this.state.keyPadDisabled} style={{width:'100%', height:'100%', fontSize:'1.3rem'}} onClick={()=>{this.onNumberEntered(6)}} className='payment-number-button-style'>6</Button>
                            </td>
                            <td>
                                <Button disabled={this.state.keyPadDisabled} style={{width:'100%', height:'100%', fontWeight:'bold', fontSize:'1.3rem', background: '#86BBD8'}} onClick={()=>{this.onNumberEntered(denominations[1] * 100)}}>{this.displayDiscountOfferTypeWithAmount(denominations[1])}</Button>
                            </td>
                        </tr>
                        
                        <tr>
                            <td>
                                <Button color="secondary" disabled={this.state.keyPadDisabled} style={{width:'100%', height:'100%', fontSize:'1.3rem'}} onClick={()=>{this.onNumberEntered(1)}} className='payment-number-button-style'>1</Button>
                            </td>
                            <td>
                                <Button color="secondary" disabled={this.state.keyPadDisabled} style={{width:'100%', height:'100%', fontSize:'1.3rem'}} onClick={()=>{this.onNumberEntered(2)}} className='payment-number-button-style'>2</Button>
                            </td>
                            <td>
                                <Button color="secondary" disabled={this.state.keyPadDisabled} style={{width:'100%', height:'100%', fontSize:'1.3rem'}} onClick={()=>{this.onNumberEntered(3)}} className='payment-number-button-style'>3</Button>
                            </td>
                            <td>
                            <Button disabled={this.state.keyPadDisabled} style={{width:'100%', height:'100%', fontWeight:'bold', fontSize:'1.3rem', background: '#F6AE2D'}} onClick={()=>{this.onNumberEntered(denominations[2] * 100)}}>{this.displayDiscountOfferTypeWithAmount(denominations[2])}</Button>
                            </td>
                        </tr>

                        <tr>
                            <td>
                                <Button color="secondary" disabled={this.state.keyPadDisabled} style={{width:'100%', height:'100%', fontWeight:'bold', fontSize:'1.3rem'}} onClick={()=>{this.onNumberEntered(-1)}} className='payment-number-button-style'>◄</Button>
                            </td>
                            <td>
                                <Button color="secondary" disabled={this.state.keyPadDisabled} style={{width:'100%', height:'100%', fontSize:'1.3rem'}} onClick={()=>{this.onNumberEntered(0)}} className='payment-number-button-style'>0</Button>
                            </td>
                            <td>
                                <Button color="secondary" disabled={this.state.keyPadDisabled} style={{width:'100%', height:'100%', fontSize:'1.3rem'}} onClick={()=>{this.onNumberEntered(-2)}} className='payment-number-button-style'>00</Button>
                            </td>
                            <td>
                            <Button disabled={this.state.keyPadDisabled} style={{width:'100%', height:'100%', fontWeight:'bold', fontSize:'1.3rem', background: '#F26419'}} onClick={()=>{this.onNumberEntered(denominations[3] * 100)}}>{this.displayDiscountOfferTypeWithAmount(denominations[3])}</Button>
                            </td>
                        </tr>

                    </table>
                </tr>
            </table>
        )
    }

    renderDiscountOfferTypePanel()
    {
        return <Button color="success" style={{width:'100%', height:'100%', fontSize:'1.3rem'}} onClick={()=>{this.onDiscountOfferTypeClick()}}>{this.displayDiscountOfferTypeWithAmount()}  <i class="fa fa-caret-down"></i></Button>
    }

    onDiscountOfferTypeClick()
    {

        if(this.state.discountOfferType == constants.DiscountVoucherTypes.Percentage)
        {
            this.state.discountOfferType = constants.DiscountVoucherTypes.Fixed;
            this.state.displayAmount = 0
        }

        else if(this.state.discountOfferType == constants.DiscountVoucherTypes.Fixed)
        {
            this.state.discountOfferType = constants.DiscountVoucherTypes.Percentage;   
            this.state.displayAmount = 0         
        }

        this.setState({});
    }

    displayDiscountOfferTypeWithAmount(num)
    {
        const stateDiscountOfferType = this.state.discountOfferType;
        const constantFixed = constants.DiscountVoucherTypes.Fixed;
        const constantPercentage = constants.DiscountVoucherTypes.Percentage;

        if(stringUtil.isStringNullOrEmpty(stateDiscountOfferType))
        {
            this.state.discountOfferType = constants.DiscountVoucherTypes.Fixed;
            this.setState({});
        }

        if(stateDiscountOfferType == constantFixed)
        {
            if(num == null)  return localizationUtils.getCurrencySymbol(); 
            return formatter.convertToCurrencyFormat(num);
        }

        if(stateDiscountOfferType == constantPercentage)
        {
            if(num == null)  return "%"; 
            return `${formatter.convertToAmountFormat(num)}%`;
        }
    }

    renderDiscountReasonPanel()
    {
        var buttonComponents = [];
        var discountReasons = [
            translator.getLabel("missing_items"),
            translator.getLabel("late_order"),
            translator.getLabel("wrong_order"),
            translator.getLabel("compliment_customer")
        ]

        discountReasons.forEach((reason) => buttonComponents.push(
            <DropdownItem>
                <Button color="dark" style={{minWidth:'600px', height:'100%', fontSize:'1.3rem'}} onClick={()=>{this.setState((state) => state.discountReason = reason)}}>{reason}</Button>
            </DropdownItem>
        ))

        return(
            <ButtonDropdown color="warning" style={{width:'100%', height:'100%', fontSize:'1.3rem'}} isOpen={this.state.discountReasonDropdownOpen} toggle={()=>{
                this.state.discountReasonDropdownOpen = !this.state.discountReasonDropdownOpen;
                this.setState({})
            }}>
                
                <DropdownToggle color="warning" style={{width:'100%', height:'100%', fontSize:'1.3rem'}} caret>
                    {translator.getLabel("discount_reasons")}
                </DropdownToggle>

                <DropdownMenu>
                    {buttonComponents}
                </DropdownMenu>

            </ButtonDropdown>)
         
    }

    renderMinimumOrderAmountPanel()
    {
        var buttonComponents = [];
        var minimumOrderAmounts = [
            0,
            10,
            20,
            50,
            100
        ]

        minimumOrderAmounts.forEach((amount) => buttonComponents.push(
            <DropdownItem>
                <Button color="dark" style={{minWidth:'300px', height:'100%', fontSize:'1.3rem'}} onClick={()=>{this.setState((state) => state.minimumOrderAmount = amount)}}>{formatter.convertToCurrencyFormat(amount)}</Button>
            </DropdownItem>
        ))

        return(
            <ButtonDropdown color="danger" style={{width:'100%', height:'100%', fontSize:'1.3rem'}} isOpen={this.state.minimumOrderAmountDropdownOpen} toggle={()=>{
                this.state.minimumOrderAmountDropdownOpen = !this.state.minimumOrderAmountDropdownOpen;
                this.setState({})
            }}>
                
                <DropdownToggle color="danger" style={{width:'100%', height:'100%', fontSize:'1.3rem'}} caret>
                    {translator.getLabel("minimum_order_amount")}
                </DropdownToggle>

                <DropdownMenu>
                    {buttonComponents}
                </DropdownMenu>

            </ButtonDropdown>)
    }

    onNumberEntered(number)
    {
        let denominations;
        if(this.state.discountOfferType == constants.DiscountVoucherTypes.Fixed)
            denominations = localizationUtils.getCurrencyDenominations();
        else
            denominations = percentageDenominations;

        if (denominations.some(x => x * 100 === number))
        {
            this.state.displayAmount = 0;     
        }

        if (number >= 0)
        {
            this.state.displayAmount = formatter.roundUp(this.state.displayAmount * 10 + number / 100, 2);

            if(this.state.discountOfferType == constants.DiscountVoucherTypes.Percentage && this.state.displayAmount > 100)
            {
                var errorMessage = "Percentage cannot be greater than 100";

                this.state.displayAmount = 100;
                viewUtil.showErrorAlert(errorMessage);
            }                            
        }

        if (number == -1)
        {
            this.state.displayAmount = formatter.roundUp(Math.round(100 * this.state.displayAmount/10) / 100, 2);
        }

        if (number == -2)
        {
            this.state.displayAmount = formatter.roundUp(this.state.displayAmount * 100, 2);
        }


        this.setState({});
    }

    onBackButtonClick()
    {
        this.props.history.push('/');
    }

    async onCreateButtonClick()
    {
        var discountVoucher = {};
        discountVoucher.id = guidUtil.generateGuid();
        discountVoucher.code = this.state.voucherCode;
        discountVoucher.franchisorId = stateManager.getStore().getState().orgData.franchisor.id;
        discountVoucher.franchiseeId = stateManager.getStore().getState().orgData.franchisee.id;
        discountVoucher.type = this.state.discountOfferType;
        discountVoucher.value = [this.state.displayAmount];
        discountVoucher.startDate = dateUtil.getToday();
        discountVoucher.expiryDate = dateUtil.addMonths(dateUtil.getToday(), 1);
        discountVoucher.isDisabled = false;
        discountVoucher.minimumOrderValue = this.state.minimumOrderAmount;
        discountVoucher.inclusiveVenueCodes = [];
        discountVoucher.inclusiveChannels = [];
        discountVoucher.inclusiveDispatchTypes = [];
        discountVoucher.inclusivePropertyIds = [commonUtility.getProperty().id];
        discountVoucher.exclusivePropertyIds = [];
        discountVoucher.claimType = constants.DiscountVoucherClaimType.oneTimeOnlyGuest;      
        discountVoucher.claimMaxLimit = null;  
        discountVoucher.marketingCampaignCaption = "";
        discountVoucher.notes = `Issued by ${staffUtility.getLoginStaffCompleteName()} (Reason: ${this.state.discountReason})`;

        var errorMessage = this.validateDiscountVoucher(discountVoucher);

        if(errorMessage) 
        {
            viewUtil.showErrorAlert(errorMessage);
            return;
        }

        await this.postDiscountVoucher(discountVoucher);        
    }

    validateDiscountVoucher(discountVoucher)
    {

        if (stringUtil.isStringNullOrEmpty(discountVoucher.id))
            return translator.getLabel("voucher_id_cannot_be_left_empty_or_null")

        if (stringUtil.isStringNullOrEmpty(discountVoucher.code))
            return translator.getLabel("voucher_code_cannot_be_left_empty_or_null")

        if (stringUtil.isStringNullOrEmpty(discountVoucher.type))
            return translator.getLabel("voucher_type_cannot_be_left_empty_or_null")

        if (!validator.isGreaterThanZero(discountVoucher.value[0]))
            return translator.getLabel("voucher_value_cannot_be_zero")

        if (stringUtil.isStringNullOrEmpty(discountVoucher.startDate) || !dateUtil.isValidDate(discountVoucher.startDate))
            return translator.getLabel("voucher_start_date_is_not_valid")

        if (!stringUtil.isStringNullOrEmpty(discountVoucher.minimumOrderValue) && !validator.isGreaterThanOrEqualToZero(discountVoucher.minimumOrderValue))
            return translator.getLabel("minimum_order_value_is_not_valid")

        if(this.state.discountOfferType == constants.DiscountVoucherTypes.Fixed)
        {
            if(!staffAccessUtility.canStaffIssueFixedDiscount(staffUtility.getLoginStaff(), this.state.displayAmount))
                return translator.getLabel("you_do_not_have_sufficient_privileges_to_issue_a_discount")
        }

        if(this.state.discountOfferType == constants.DiscountVoucherTypes.Percentage)
        {
            if(!staffAccessUtility.canStaffIssuePercentageDiscount(staffUtility.getLoginStaff(), this.state.displayAmount))
                return translator.getLabel("you_do_not_have_sufficient_privileges_to_issue_a_discount")
        }

        if(stringUtil.isStringNullOrEmpty(discountVoucher.notes))
        {
            return translator.getLabel("discount_reason_is_not_selected")
        }

        return null;
    }

    async postDiscountVoucher(discountVoucher)
    {

        jobsServer.addJob(guidUtil.generateGuid(), "Discount.Voucher.Saving", 
        async ()=>
        {
            await rmsApiProxyRetry.post(`${rmsApiProxyRetry.getFranchiseeOrgContextUrl()}/promotions/vouchers`, discountVoucher);
            return true;
        })

        const offer = buildOfferInformation(); 
        printUtil.printVoucherCode(offer, discountVoucher.code, discountVoucher.id, discountVoucher.startDate, discountVoucher.expiryDate);
        this.handleCancel();
        viewUtil.showSuccessAlert("Discount Voucher issued successfully")

        function buildOfferInformation()
        {
            const value = discountVoucher.value[0];
            
            let offer;

            if (discountVoucher.type === constants.DiscountVoucherTypes.Fixed)
                offer = formatter.convertToCurrencyFormat(value);
            else
                offer = formatter.convertToPercentageFormat(value);

            if (validator.isGreaterThanZero(discountVoucher.minimumOrderValue))
                offer = `Redeem the voucher to get ${offer} off on your order over ${formatter.convertToCurrencyFormat(discountVoucher.minimumOrderValue)}.`;
            else
                offer = `Redeem the voucher to get ${offer} off your order.`;

            return offer;
        }
    }

    handleCancel()
    {
        stateManager.getStore().dispatch(navigationDialogueAction.createAction(null));
    }
}

export default DiscountVoucherView;